<script>
import MetricItem from "@views/admin/treasury/trust-management/structured-lenders/MetricItem.vue";
import {formatMoney} from "@components/admin/filters";
import LoanManagementTable from "@views/admin/treasury/trust-management/structured-lenders/LoanManagementTable.vue";
import ConsolidatedCommissionTableButton
  from "@views/admin/treasury/trust-management/structured-lenders/ConsolidatedCommissionTableButton.vue";
import ConsolidatedFlowTableButton
  from "@views/admin/treasury/trust-management/structured-lenders/ConsolidatedFlowTableButton.vue";

export default {
  name: "StructuredLenderItem",
  components: {ConsolidatedFlowTableButton, ConsolidatedCommissionTableButton, LoanManagementTable, MetricItem},
  props: {
    structuredLender: {
      type: Object,
      default: {}
    }
  },
  data: () => ({
    dialogActive: false,
    loanManagementDialogActive: false,
    form: {
      name: null,
      discountRate: 0,
      loanToValueRatio: 0,
      amount: 0,
      balanceConcentration: 0,
      commissionConcentration: 0
    }
  }),
  methods: {
    formatMoney,
    formatPercentage(value) {
      return `${value}%`;
    },
    editDiscountRateHandler() {
      this.dialogActive = true;

      this.form.name = this.structuredLender.name;
      this.form.discountRate = this.structuredLender.discount_rate;
      this.form.loanToValueRatio = this.structuredLender.loan_to_value_ratio;
      this.form.amount = this.structuredLender.amount;
      this.form.commissionConcentration = this.structuredLender.commission_concentration;
      this.form.balanceConcentration = this.structuredLender.balance_concentration;
    },
    async saveDiscountRateHandler() {
      this.$vs.loading();
      try {
        await axios.put(`/api/backoffice/treasury/trust-management/structured-lender/${this.structuredLender.id}`, {
          name: this.form.name,
          discount_rate: this.form.discountRate,
          loan_to_value_ratio: this.form.loanToValueRatio,
          amount: this.form.amount,
          balance_concentration: this.form.balanceConcentration,
          commission_concentration: this.form.commissionConcentration
        });

        this.$vs.loading.close();
        this.dialogActive = false;

        this.structuredLender.name = this.form.name;
        this.structuredLender.amount = this.form.amount;
        this.structuredLender.loan_to_value_ratio = this.form.loanToValueRatio;
        this.structuredLender.discount_rate = this.form.discountRate;
        this.structuredLender.balance_concentration = this.form.balanceConcentration;
        this.structuredLender.commission_concentration = this.form.commissionConcentration;

      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: "Ocurrió un error al guardar los datos",
          color: "danger"
        });
      }
    },
    registerProjectChangedHandler(ev) {
      this.$emit("onChanged", ev);
      this.loanManagementDialogActive = false;
    }
  }
}
</script>

<template>
  <div>
    <vx-card :title="structuredLender.name" class="mt-5">
      <div class="grid grid-cols-2 gap-8 text-sm">
        <vx-card classContent="relative">
          <vs-button
              @click="editDiscountRateHandler"
              class="small edit-btn rounded-full"
              color="#000"
              icon="edit"></vs-button>

          <metric-item title="Monto" :value="formatMoney(structuredLender.amount)" />
          <metric-item title="Aforo" :value="structuredLender.loan_to_value_ratio" />
          <metric-item title="Tasa de descuento" :value="(structuredLender.discount_rate * 100)" />
          <metric-item title="Concentración" :value="formatPercentage(structuredLender.balance_concentration * 100)" />
          <div class="flex justify-end gap-2 mt-10">
            <consolidated-commission-table-button
                :structured-lender-id="structuredLender.id" />

            <consolidated-flow-table-button
                :structured-lender-id="structuredLender.id" />

            <vs-button
                @click="loanManagementDialogActive = true"
                size="small"
                class="uppercase">Créditos en aforo</vs-button>
          </div>
        </vx-card>

        <!--<vx-card>
          <metric-item
              title="Inversión efectiva"
              :value="formatMoney(structuredLender.effective_investment)"/>

          <metric-item
              title="VPN Comisión Solicitante"
              :value="formatMoney(structuredLender.vpn_applicant_commission)"/>

          <metric-item
              title="VPN Comisión Inversionista (Inversión Verde I260)"
              :value="formatMoney(structuredLender.vpn_investment_green_commission)"/>

          <metric-item
              title="VPN Comisión Inversionista (Inversión RedGirasol I262)"
              :value="formatMoney(structuredLender.vpn_investment_rg_commission)"/>

          <metric-item
              title="Aforo actual calculado"
              :value="formatMoney(structuredLender.value_ratio_total)"/>

          <metric-item
              title="Total de proyectos asignados"
              :value="formatMoney(structuredLender.total_project_assigned)"/>

          <div class="flex justify-end gap-4 mt-5">
            <consolidated-commission-table-button
                :structured-lender-id="structuredLender.id" />

            <consolidated-flow-table-button
              :structured-lender-id="structuredLender.id" />

            <vs-button
                @click="loanManagementDialogActive = true"
                size="small"
                class="uppercase">Créditos en aforo</vs-button>
          </div>
        </vx-card>-->
      </div>
    </vx-card>

    <vs-popup title="Editar prestamista" :active.sync="dialogActive" :key="structuredLender.id">
      <div class="flex flex-col gap-2">
        <vs-input class="w-full" v-model="form.name" label="Nombre" />
        <vs-input class="w-full" v-model="form.amount" label="Monto" />
        <small class="font-bold">{{formatMoney(form.amount)}} mxn</small>
        <vs-input class="w-full" v-model="form.loanToValueRatio" label="Aforo" />
        <vs-input class="w-full" v-model="form.discountRate" label="Tasa de descuento" />
        <vs-input class="w-full" v-model="form.balanceConcentration" label="Concentración" />

        <vs-button class="mt-2" @click="saveDiscountRateHandler" color="primary">Guardar</vs-button>
      </div>
    </vs-popup>

    <vs-popup fullscreen title="Créditos en aforo" :active.sync="loanManagementDialogActive">
      <loan-management-table
          @onProjectsChanged="registerProjectChangedHandler"
          v-if="loanManagementDialogActive === true"
          :structuredLender="structuredLender" />
    </vs-popup>
  </div>
</template>

<style scoped>
.edit-btn {
  position: absolute;
  top: -10px;
  right: -10px;
}
</style>